import { render, staticRenderFns } from "./LadderToPay.vue?vue&type=template&id=24a6651f&scoped=true"
import script from "./LadderToPay.vue?vue&type=script&lang=js"
export * from "./LadderToPay.vue?vue&type=script&lang=js"
import style0 from "./LadderToPay.vue?vue&type=style&index=0&id=24a6651f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a6651f",
  null
  
)

export default component.exports